import React, { useState } from 'react'
import { Box, Typography, Card, CardContent, Avatar, Chip, TablePagination, CircularProgress, Paper, IconButton, FormControl, InputLabel, Select, MenuItem, ToggleButton, ToggleButtonGroup, Tooltip, Alert } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ViewListIcon from '@mui/icons-material/ViewList'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import PhoneIcon from '@mui/icons-material/Phone'
import CallIcon from '@mui/icons-material/Call'
import ListIcon from '@mui/icons-material/List'
import SettingsIcon from '@mui/icons-material/Settings'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import CallEndIcon from '@mui/icons-material/CallEnd';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import { short, sip, shortFunctionList, input, employee, group, group as groupTranslate, did, telecomunication, global } from "../../translate";
import Utils from "../../Utils";
import Cookies from "js-cookie";
import Api from "../../Api";
import { toast } from 'react-toastify';
import { activitiesStyles, employeeTableStyles } from "../../helpers/style";
import AssignedSearch from "./AssignedSearch";
import { useSelector } from 'react-redux';
const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

export default function ShortTable({
    data = [],
    telegram = [],
    whatsapp = [],
    setData = () => { },
    loading = false,
    title = '',
    viewMode = 'table',
    onViewModeChange = () => { }
}) {
    const langIndex = +localStorage.getItem('atsLang') || 1
    const [searchQuery, setSearchQuery] = useState('')
    const navigate = useNavigate()
    const [sortBy, setSortBy] = useState(null)
    const [sortOrder, setSortOrder] = useState(null)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(Cookies.get("short") ? parseInt(Cookies.get("short")) : 10)
    const [copied, setCopied] = useState(false)
    const [chipFilter, setChipFilter] = useState('all') // 'all' | 'multi' | 'telegram' | 'whatsapp'
    const employeeData = useSelector(state => state.users.employeeData)
    const onEdit = (id) => {
        navigate(`/groups/${id}`)
    }
    const onDelete = async (id) => {
        const deleteText = langIndex === 1 ? "Are you sure you want to delete?" :
            langIndex === 2 ? "Вы уверены, что хотите удалить?" :
                "Վստա՞հ եք, որ ցանկանում եք ջնջել"

        if (window.confirm(deleteText)) {
            try {
                const response = await Api.groupsDelete(id)
                if (response?.data?.status === 'ok') {
                    toast.success(global.deleted[langIndex])
                    setData((prev) => prev.filter((g) => String(g.id) !== String(id)))
                }
            } catch (error) {
                console.error('Error deleting group:', error)
                toast.error('Error deleting group')
            }
        }
    }
    const onAdd = () => {
        navigate('/groups/add')
    }
    const titleArr = [
        sip.note[langIndex],
        sip.phone[langIndex],
        short.short[langIndex],
        short.list[langIndex],
        short.no_answer[langIndex],
    ]

    let descArr = []

    const handleSearchChange = (value) => {
        setSearchQuery(value)
    }

    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
        } else {
            setSortBy(column)
            setSortOrder('asc')
        }
    }

    // Filter data based on search query
    const filteredData = searchQuery
        ? data.filter(item => {
            const query = searchQuery.toLowerCase()
            const searchableFields = [
                item.name,
                item.virtual,
                item.noaction,
                item.item_count
            ]
            return searchableFields.some(field =>
                field !== null &&
                field !== undefined &&
                String(field).toLowerCase().includes(query)
            )
        })
        : data

    const matchesChipFilter = (s) => {
        switch (chipFilter) {
            case 'multi':
                return !!s?.cwaiting
            case 'telegram':
                return !!s?.telegram
            case 'whatsapp':
                return !!s?.whatsapp
            default:
                return true
        }
    }
    const chipFilteredData = filteredData.filter(matchesChipFilter)

    // Sort filtered data
    const sortedData = [...chipFilteredData].sort((a, b) => {
        if (!sortBy) return 0

        let aValue, bValue

        switch (sortBy) {
            case 'name':
                aValue = a.name || ''
                bValue = b.name || ''
                break
            case 'mobnum':
                aValue = a.redirect_outputs || ''
                bValue = b.redirect_outputs || ''
                break
            case 'virtual':
                aValue = a.virtual || ''
                bValue = b.virtual || ''
                break
            case 'list':
                aValue = a.item?.length || a.item_count || 0
                bValue = b.item?.length || b.item_count || 0
                break
            case 'noaction':
                aValue = a.noaction || ''
                bValue = b.noaction || ''
                break
            default:
                return 0
        }

        if (sortOrder === 'asc') {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
        } else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
        }
    })

    // Prepare data for export
    descArr = sortedData.map(s => ({
        notes: s?.name || '',
        out: s?.redirect_outputs || '',
        virtual: s.virtual || '',
        list: s?.item?.length || s?.item_count || 0,
        noAnswer: s.noaction || ''
    }))

    // Paginate data
    const paginatedData = rowsPerPage > 0
        ? sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : sortedData

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10)
        setRowsPerPage(newRowsPerPage)
        setPage(0)
        Cookies.set("short", newRowsPerPage, { expires: 30 })
    }

    return (
        <div className="tableParent" id="tableParent">
            <Paper sx={{ p: 3, boxShadow: 3 }}>
                <Box sx={employeeTableStyles.headerBox}>
                    <Box sx={employeeTableStyles.headerTitleBox}>
                        <Typography sx={employeeTableStyles.title} variant="h5" component="h1">{title}</Typography>
                    </Box>
                    {/* <ToggleButtonGroup
                        value={viewMode}
                        exclusive
                        onChange={onViewModeChange}
                        aria-label="view mode"
                        size="small"
                    >
                        <ToggleButton value="table" aria-label="table view">
                            <ViewListIcon />
                        </ToggleButton>
                        <ToggleButton value="card" aria-label="card view">
                            <ViewModuleIcon />
                        </ToggleButton>
                    </ToggleButtonGroup> */}
                </Box>
                <Box sx={employeeTableStyles.searchSortContainer}>
                    <Box sx={employeeTableStyles.searchBox}>
                        <AssignedSearch
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onAdd={onAdd}
                            placeholder={input.search?.[langIndex] || 'Search...'}
                            showAdd={true}
                            addColor={color}
                        />
                    </Box>
                    <Box sx={employeeTableStyles.sortContainer}>
                        <FormControl size="small" sx={employeeTableStyles.sortFormControl}>
                            <InputLabel>{input.sortBy[langIndex]}</InputLabel>
                            <Select
                                value={sortBy || ''}
                                label={input.sortBy[langIndex]}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        handleSort(e.target.value)
                                    } else {
                                        setSortBy(null)
                                        setSortOrder(null)
                                    }
                                }}
                                sx={employeeTableStyles.sortSelect}
                            >
                                <MenuItem value="">
                                    <em>{input.none[langIndex]}</em>
                                </MenuItem>
                                <MenuItem value="name">{input.name[langIndex]}</MenuItem>
                                <MenuItem value="virtual">{short.private[langIndex]}</MenuItem>
                                <MenuItem value="list">{short.list[langIndex]}</MenuItem>
                                <MenuItem value="noaction">{group.no_answer_short_label[langIndex]}</MenuItem>
                            </Select>
                        </FormControl>
                        {sortBy && (
                            <IconButton
                                size="small"
                                onClick={() => handleSort(sortBy)}
                                sx={employeeTableStyles.getSortIconButton(color)}
                                aria-label={sortOrder === 'asc' ? input.sortDesc[langIndex] : input.sortAsc[langIndex]}
                            >
                                {sortOrder === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                            </IconButton>
                        )}
                    </Box>
                </Box>

                {loading ? (
                    <Box sx={employeeTableStyles.loadingBox}>
                        <CircularProgress sx={{ color }} />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ mb: 2 }}>
                            <ToggleButtonGroup
                                value={chipFilter}
                                exclusive
                                onChange={(e, value) => { if (value != null) setChipFilter(value); setPage(0) }}
                                size="medium"
                                sx={{
                                    flexWrap: 'wrap',
                                    '& .MuiToggleButton-root': { textTransform: 'none', py: 1, px: 2, fontSize: '0.95rem' },
                                    '& .MuiToggleButton-root.Mui-selected': { backgroundColor: color, color: '#fff', '&:hover': { backgroundColor: color } },
                                }}
                            >
                                <ToggleButton value="all" aria-label="all">
                                    {did.all?.[langIndex] ?? 'All'}
                                </ToggleButton>
                                <ToggleButton
                                    value="multi"
                                    aria-label="multi"
                                    sx={{
                                        '&.Mui-selected': {
                                            backgroundColor: `${color} !important`,
                                            color: '#fff !important',
                                            '&:hover': { backgroundColor: `${color} !important` },
                                        },
                                    }}
                                >
                                    <AddIcCallIcon sx={{ fontSize: 22, mr: 0.75 }} />
                                    {group.multi_call_label?.[langIndex] ?? 'Multi'}
                                </ToggleButton>
                                <ToggleButton
                                    value="telegram"
                                    aria-label="telegram"
                                    sx={{
                                        '&.Mui-selected': {
                                            backgroundColor: '#0088cc !important',
                                            color: '#fff !important',
                                            '&:hover': { backgroundColor: '#0077b5 !important' },
                                        },
                                    }}
                                >
                                    <TelegramIcon sx={{ fontSize: 22, mr: 0.75 }} />
                                    {telecomunication.telegram_title?.[langIndex] ?? 'Telegram'}
                                </ToggleButton>
                                <ToggleButton
                                    value="whatsapp"
                                    aria-label="whatsapp"
                                    sx={{
                                        '&.Mui-selected': {
                                            backgroundColor: '#25D366 !important',
                                            color: '#fff',
                                            '&:hover': { backgroundColor: '#1da851 !important' },
                                        },
                                    }}
                                >
                                    <WhatsAppIcon sx={{ fontSize: 22, mr: 0.75 }} />
                                    {telecomunication.whatsapp_title?.[langIndex] ?? 'WhatsApp'}
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        {chipFilter === 'multi' && (
                            <Alert
                                severity="success"
                                icon={<AddIcCallIcon />}
                                sx={
                                    REACT_APP_SERVER !== 'ATS'
                                        ? { mb: 3 }
                                        : {
                                            mb: 3,
                                            border: `1px solid ${color}`,
                                            backgroundColor: `${color}10`,
                                            '& .MuiAlert-icon': { color },
                                        }
                                }
                            >
                                <Typography variant="body2" component="span">
                                    {group.multi_call_desc?.[langIndex] ?? 'Simultaneous calls'}
                                </Typography>
                            </Alert>
                        )}
                        {chipFilter === 'telegram' && (
                            <Alert
                                severity="info"
                                icon={<TelegramIcon sx={{ color: '#0088cc' }} />}
                                sx={{
                                    mb: 2,
                                    backgroundColor: 'rgba(0, 136, 204, 0.08)',
                                    border: '1px solid rgba(0, 136, 204, 0.3)',
                                    '& .MuiAlert-message': { width: '100%' },
                                }}
                            >
                                <Typography variant="body2" component="span">
                                    {telecomunication.telegram_desc_group?.[langIndex] ?? 'Connect Telegram to exchange messages and manage customer communication in real time.'}
                                </Typography>
                            </Alert>
                        )}
                        {chipFilter === 'whatsapp' && (
                            <Alert
                                severity="info"
                                icon={<WhatsAppIcon sx={{ color: '#25D366' }} />}
                                sx={{
                                    mb: 2,
                                    backgroundColor: 'rgba(37, 211, 102, 0.08)',
                                    border: '1px solid rgba(37, 211, 102, 0.3)',
                                    '& .MuiAlert-message': { width: '100%' },
                                }}
                            >
                                <Typography variant="body2" component="span">
                                    {telecomunication.whatsapp_desc_group?.[langIndex] ?? 'Connect WhatsApp to send and receive messages and communicate with customers directly from the system.'}
                                </Typography>
                            </Alert>
                        )}
                        {paginatedData.length ? (
                            <>
                        <Box sx={activitiesStyles.activitiesContainer}>
                            {paginatedData.map((s) => {
                                const displayName = s?.name || (s?.item?.length ? s?.item[0]?.member_buddy?.[0]?.notes : '') || ''
                                const isWaiting = s?.cwaiting

                                return (
                                    <Card key={s.id} sx={{ ...activitiesStyles.activityCard, '&:hover': { boxShadow: `0 8px 24px ${color}26`, borderColor: color } }}>
                                        <CardContent sx={activitiesStyles.cardContent}>
                                            <Box sx={activitiesStyles.cardContentBox}>
                                                <Avatar sx={{
                                                ...activitiesStyles.getActivityAvatar(isWaiting),
                                                ...(isWaiting && { bgcolor: color, boxShadow: `0 4px 12px ${color}4D` }),
                                            }}>
                                                    {displayName?.[0]?.toUpperCase() || 'G'}
                                                </Avatar>

                                                <Box sx={activitiesStyles.activityContentBox}>
                                                    <Box sx={{ ...activitiesStyles.chipsContainer, gap: 1.5 }}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}
                                                            title="Multi"
                                                        >
                                                            <AddIcCallIcon sx={{ fontSize: 25, color: isWaiting ? color : 'grey.500' }} />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: telegram.find(t => +t.group_id === +s.virtual) ? '#0088cc' : 'grey.500',
                                                            }}
                                                            title="Telegram"
                                                        >
                                                            <TelegramIcon sx={{ fontSize: 25 }} />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: whatsapp.find(w => +w.group_id === +s.virtual) ? '#25D366' : 'grey.500',
                                                            }}
                                                            title="WhatsApp"
                                                        >
                                                            <WhatsAppIcon sx={{ fontSize: 25 }} />
                                                        </Box>
                                                    </Box>

                                                    <Typography variant="h6" sx={activitiesStyles.activityTitle}>
                                                        {displayName}
                                                    </Typography>

                                                    <Box sx={activitiesStyles.metadataBox}>


                                                        <Box sx={activitiesStyles.metadataItem}>
                                                            <CallIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                            <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                <strong>{employee.short_number_label[langIndex]}:</strong> {s.virtual}
                                                            </Typography>
                                                        </Box>
                                                        {s?.noaction || String(s.noaction) === '0' ? (() => {
                                                            const noVal = String(s.noaction)
                                                            const groupVirtuals = (data || []).map((g) => String(g.virtual))
                                                            const isGroup = groupVirtuals.includes(noVal)
                                                            const isFunctionCode = shortFunctionList[noVal]?.length
                                                            const name = isFunctionCode ? shortFunctionList[noVal][langIndex] : (data?.find((g) => String(g.virtual) === noVal)?.name || noVal)
                                                            const displayText = isFunctionCode ? name : noVal
  return (
                                                                <Box
                                                                    sx={{
                                                                        ...activitiesStyles.metadataItem,
                                                                        flexWrap: 'wrap',
                                                                        gap: 0.75,
                                                                    }}
                                                                >
                                                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <PhoneMissedIcon fontSize="small" sx={{ ...activitiesStyles.metadataIcon, color: '#d32f2f', fontSize: 16 }} />
                                                                        <Typography component="span" variant="caption" sx={{ ...activitiesStyles.metadataText, fontWeight: 600 }}>
                                                                            {group.no_answer_short_label[langIndex]}:
                                                                        </Typography>
                                                                    </Box>
                                                                    <Tooltip title={name} placement="top">
                                                                        <Box
                                                                            component="span"
                                                                            sx={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: 0.5,
                                                                                px: 1,
                                                                                py: 0.25,
                                                                                borderRadius: 1,
                                                                                backgroundColor: 'action.hover',
                                                                                border: '1px solid',
                                                                                borderColor: 'divider',
                                                                                fontSize: '0.8rem',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            {isFunctionCode ? (
                                                                                noVal === '59999' || noVal === '100097' ? <VoicemailIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} /> : noVal === '10888' ? <CallEndIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} /> : <PhoneIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} />
                                                                            ) : isGroup ? (
                                                                                <GroupIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} />
                                                                            ) : (
                                                                                <GraphicEqIcon fontSize="small" sx={{ color, mr: 0.25, fontSize: 16 }} />
                                                                            )}
                                                                            <Typography component="span" variant="caption" sx={activitiesStyles.metadataText}>
                                                                                {displayText}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Tooltip>
                                                                </Box>
                                                            )
                                                        })() : null}
                                                        {(s?.item?.length || s?.item_count) ? (
                                                            <Box sx={activitiesStyles.metadataItem}>
                                                                <ListIcon fontSize="small" sx={{ color, mr: 0.5, fontSize: '18px' }} />
                                                                <Typography variant="caption" sx={activitiesStyles.metadataText}>
                                                                    <strong>{short.list[langIndex]}:</strong> {s?.item?.length || s?.item_count || 0}
                                                                </Typography>
                                                            </Box>
                                                        ) : null}
                                                        
                                                    </Box>
                                                </Box>

                                                <Box sx={employeeTableStyles.actionsContainer}>
                                                    
                                                    <Box sx={employeeTableStyles.actionButtonsBox}>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => onEdit(s.id)}
                                                            sx={{
                                                                color,
                                                                '&:hover': {
                                                                    backgroundColor: `${color}15`,
                                                                    transform: 'scale(1.1)',
                                                                },
                                                                transition: 'all 0.2s ease',
                                                                padding: '6px',
                                                            }}
                                                            aria-label="Edit"
                                                        >
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </IconButton>
                                                        {employeeData?.buddy? null :<IconButton
                                                            size="small"
                                                            onClick={() => onDelete(s.id)}
                                                            sx={{ ...employeeTableStyles.deleteIconButton, }}
                                                            aria-label="Delete"
                                                        >
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </IconButton>}
                                                    </Box>
                                                    
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                )
                            })}
                        </Box>
                        <Box sx={employeeTableStyles.footerBox}>
                            <Box className="footer-chip-box" sx={{
                                ...employeeTableStyles.footerLinksBox,
                                '& .MuiChip-root': { borderColor: color },
                                '& .MuiChip-root:hover': { backgroundColor: `${color} !important`, color: '#fff !important', borderColor: `${color} !important` },
                                '& .MuiChip-root:hover .MuiChip-label': { color: '#fff !important' },
                            }}>
                                <Chip label="EXCEL" variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label="CSV" variant="outlined" size="small" onClick={() => Utils.dataToExel(titleArr, descArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label="PRINT" variant="outlined" size="small" onClick={() => window.print()} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                                <Chip label="COPY" variant="outlined" size="small" onClick={() => Utils.copy(setCopied)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: color, color: '#fff', borderColor: color } }} />
                            </Box>
                            <TablePagination
                                rowsPerPageOptions={[10, 18, 27, 36, { label: did.all[langIndex], value: -1 }]}
                                component="div"
                                count={sortedData.length}
                                labelRowsPerPage={input.rowsPerPage[langIndex]}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Box>
                            </>
                        ) : (
                            <Box sx={employeeTableStyles.emptyStateBox}>
                                <Typography variant="body1" color="text.secondary">
                                    {groupTranslate.no_found[langIndex]}
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
            </Paper>
            {copied ? <div className="copied">Copied</div> : null}
        </div>
  )
}
